<div class="row">
  <div class="col-sm-12">
    <label class="control-label">
      <span style="font-weight: bold;">{{ 'forms.form-builder.field-settings' | translate | titlecase }}</span>
    </label>
  </div>
</div>
<div class="row">
  <ul class="list-unstyled">
    <li>
      <div class="col-sm-6 mct-flex mct-col mb-12">
        <label class="control-label">
          <input type="checkbox" [(ngModel)]="listingSettings.ListingCategory.Visible" disabled="disabled" />
          {{ 'listing.listing-category' | translate | titlecase }}
        </label>
        <input
          type="text"
          placeholder="{{ 'common.optional-label-text' | translate | titlecase }}"
          [(ngModel)]="listingSettings.ListingCategory.LabelText"
        />
      </div>
      <div class="col-sm-6 mct-flex mct-col mb-12">
        <label class="control-label">
          <input type="checkbox" [(ngModel)]="listingSettings.ListingSubCategory.Visible" />
          {{ 'listing.listing-subcategory' | translate | titlecase }}
        </label>
        <input
          type="text"
          placeholder="{{ 'common.optional-label-text' | translate | titlecase }}"
          [(ngModel)]="listingSettings.ListingSubCategory.LabelText"
        />
      </div>
      <div style="clear: both;"></div>
    </li>
    <li style="margin-top: 10px;">
      <div class="col-sm-6 mct-flex mct-col mb-12">
        <label class="control-label">
          <input type="checkbox" [(ngModel)]="listingSettings.LongDescription.Visible" />
          {{ 'listing.long-description' | translate | titlecase }}
        </label>
        <input
          type="text"
          placeholder="{{ 'common.optional-label-text' | translate | titlecase }}"
          [(ngModel)]="listingSettings.LongDescription.LabelText"
        />
      </div>
      <div class="col-sm-6 mct-flex mct-col mb-12">
        <label class="control-label">
          <input type="checkbox" [(ngModel)]="listingSettings.ShortDescription.Visible" />
          {{ 'listing.short-description' | translate | titlecase }}
        </label>
        <input
          type="text"
          placeholder="{{ 'common.optional-label-text' | translate | titlecase }}"
          [(ngModel)]="listingSettings.ShortDescription.LabelText"
        />
      </div>
      <div style="clear: both;"></div>
    </li>
    <li style="margin-top: 10px;">
      <div class="col-sm-6 mct-flex mct-col mb-12">
        <label class="control-label">
          <input type="checkbox" [(ngModel)]="listingSettings.Keywords.Visible" />
          {{ 'listing.keywords' | translate | titlecase }}
        </label>
        <input
          type="text"
          placeholder="{{ 'common.optional-label-text' | translate | titlecase }}"
          [(ngModel)]="listingSettings.Keywords.LabelText"
        />
      </div>
      <div style="clear: both;"></div>
    </li>
  </ul>
</div>

<div class="row" style="min-height: 34px;">&nbsp;</div>
<div class="row">
  <div class="col-sm-12">
    <label class="control-label">
      <span style="font-weight: bold;">{{ 'forms.form-builder.additional-settings' | translate | titlecase }}</span>
    </label>
  </div>
</div>
<div class="row">
  <ul class="list-unstyled">
    <li>
      <div class="col-sm-12">
        <label class="control-label">
          <input type="checkbox" [(ngModel)]="listingSettings.Required" />
          {{ 'common.required' | translate | titlecase }}
        </label>
      </div>
      <div style="clear: both;"></div>
    </li>
    <li style="margin-top: 10px;">
      <div class="col-sm-12">
        <label class="control-label">
          <input type="checkbox" [(ngModel)]="listingSettings.AllowAdditional" />
          {{ 'forms.form-builder.listings.allow-additional-listings' | translate | titlecase }}
        </label>
      </div>
      <div style="clear: both;"></div>
    </li>
    <li style="margin-top: 10px;">
      <div class="col-sm-6 mct-flex mct-col mb-12" *ngIf="listingSettings.Field.RevenueInfo && listingSettings.Field.RevenueInfo.length">
        <label class="control-label">
          {{ 'forms.form-builder.listings.price-per-additional' | translate | titlecase }}
        </label>
        <input
          [disabled]="!listingSettings.AllowAdditional"
          type="number"
          [(ngModel)]="listingSettings.Field.RevenueInfo[0].Price"
        />
      </div>
      <div class="col-sm-6 mct-flex mct-col mb-12" *ngIf="listingSettings.Field.RevenueInfo && listingSettings.Field.RevenueInfo.length">
        <div>
          <label class="control-label">
            {{ 'forms.form-builder.listings.revenue-item' | translate | titlecase }}
          </label>
        </div>
        <div>
          <select
            [disabled]="!listingSettings.AllowAdditional"
            [(ngModel)]="listingSettings.Field.RevenueInfo[0].RevenueItemNum"
            class="form-control"
          >
            <option value="0">{{ 'common.select-one' | translate | titlecase }}</option>
            <option *ngFor="let revItem of revenueItems" [value]="revItem.ItemNum">{{ revItem.ItemName }}</option>
          </select>
        </div>
      </div>
      <div style="clear: both;"></div>
    </li>
    <li style="margin-top: 10px;">
      <div class="col-sm-6 mct-flex mct-col mb-12">
        <label class="control-label">
          {{ 'forms.form-builder.listings.limit-additional-listings' | translate | titlecase }}
        </label>
        <input
          [disabled]="!listingSettings.AllowAdditional"
          type="number"
          min="0"
          style="width:100px;"
          [(ngModel)]="listingSettings.AdditionalLimit"
          placeholder="{{ 'forms.form-builder.listings.no-limit' | translate | titlecase }}"
        />
      </div>
      <div style="clear: both;"></div>
    </li>
  </ul>
</div>
